import { useCallback, useState } from "react";
import { network as _network, NetworkInit } from "../../util/network/network";
import { useApp } from "../use-app/useApp";

export function useNetwork() {
  const app = useApp();
  const [loading, setLoading] = useState<boolean>(false);

  const network = useCallback(
    async <T>(endpoint: string, init?: NetworkInit) => {
      setLoading(true);

      try {
        return await _network<T>(app.name, endpoint, init);
      } catch (error) {
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [app],
  );

  return {
    network,
    loading,
  };
}
